module.exports = __webpack_public_path__ + "static/img/role.abce978.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/yzzzbq/role.png
// module id = pM3O
// module chunks = 7